<template>
  <div id="pagesAdmin" style="overflow:hidden;">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }} / Contenuti</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ pages }}</router-link>
      </li>
      <!--li>
        <button id="btnShare"
            class="btn btn-light"
            @click="sharepage"
          >Share</button> 
      <li-->
      <li
        style="
          float: right;
          position: absolute;
          right: 15px;
          float: right;
          position: absolute;
          right: 15px;
          font-weight: bold;
          font-size: 20px;
          color: #303c54;
          text-transform: uppercase;
          margin-top: -5px;
        "
      >
        {{ titoloPagina }}
      </li>
    </ol>
    <div class="container-fluid">
      <input type="hidden" v-model="pageValueSelected.id" />
      <div class="row">
        <div class="col-sm-4 align-self-center">
          <button
            id="btnNewPageAdminPagesView"
            class="btn btn-light"
            @click="changeView"
          ><i class="fa fa-file-o mr-1"></i>
            {{ newPage }}
          </button>
        
          <button
            id="btnNewLinkAdminPagesView"
            class="btn btn-light"
            @click="changeViewLink"
          ><i class="fa fa-link mr-1"></i>
            {{ newLink }}
          </button>
          <!--
          <button
            id="btnNewFolderAdminPagesView"
            class="btn btn-light"
            @click="changeView"
          >
            {{ newFolder }}
          </button>
          -->
        </div>
        <div class="col-sm-3 align-self-center" style="padding-bottom:0px;padding-top:0px;">
          <div class="row d-flex justify-content-end" v-if="titoloPagina">
            <div class="col-7" v-show="divLanguage">
              <span style="float:left;margin-top:10px;">
                <i class="fa fa-flag-o fr-deletable mr-2" style="font-size: 20px"></i>&nbsp;
              </span>
              <select2
                id="select_AdminPagesView_IdLanguage"
                ref="select_AdminPagesView_IdLanguage"
                class="form-control nopadding"
                style="width: 75%"
                :filterable="false"
                service="languages"
                v-model="pageValueSelected.languagePageSetting.idLanguage"
                :default="defaultLanguageOptions"
                :options="allLanguageOptions"
                :change="languageChange"
              />
            </div>
            <div class="col-5 align-self-center">
              <label
                class="switch switch-pill switch-primary"
                style="margin: 2px; vertical-align: bottom"
              >
                <input
                  type="checkbox"
                  id="checkBox_AdminPagesView_IsOnline"
                  class="switch-input"
                  v-model="pageValueSelected.online"
                />
                <span class="switch-slider" data-on data-off></span>
              </label>
              <span style="top: -3px; left:4px; position: relative">{{ online }}</span>
            </div>
          </div>
        </div>
        <div class="col-sm-5 align-self-center">
          <div class="row" v-if="titoloPagina">
            <div class="col-12 text-right" style="white-space: nowrap;padding-top:0px;padding-bottom:0px;">
              <button
                id="btnPreviewAdminPagesView"
                class="btn btn-light"
                @click="previewClick"
                v-if="typePage == 'Pages'"
              ><i class="fa fa-search mr-1"></i>
                {{ preview }}
              </button>
              <!--button
                id="btnTestAdminPagesView"
                class="btn btn-light"
                @click="testPageClick"
                v-if="typePage == 'Pages'"
              >
                Pagespeed
              </button-->
              <button class="btn btn-danger" @click="cancelPage">
                 <i class="fa fa-times"></i>
                {{ cancel }}
              </button>
              <button class="btn btn-primary" @click="savePage(false)" v-if="typePage == 'Pages'">
                 <i class="fa fa-floppy-o"></i>
                {{ save }}
              </button>
              <button class="btn btn-primary" @click="savePageLink(false)" v-else>
                 <i class="fa fa-floppy-o"></i>
                {{ save }}
              </button>
              <button class="btn btn-success" @click="savePage(true)" v-if="typePage == 'Pages'">
                 <i class="fa fa-floppy-o"></i>
                {{ saveAndPublish }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          id="divMenuAdminPagesView"
          class="col-sm-2"
          style="transition: all 0.5s ease-in-out;margin-top:12px;"
        >
          <div class="card" style="border:0px">
            <div id="cardHeaderMenuAdminPagesView" class="card-header" style="padding: 1.35rem;">
              <i class="nav-icon fa fa-bars"></i>&nbsp;
              <h5>{{ menu }}</h5>
            </div>
            <div class="tab-content" style="background: #e4e5e6; border: 0px solid #e4e5e6;">
              <div
                id="divRowMenuDesktopAdminPagesView"
                class="card-body tab-pane active nopadding"
                role="tabpanel"
                style="box-shadow:none;"
              >
                <menu-draggable :list="menuList" />
              </div>
            </div>
          </div>
          <div class="card">
            <div class="card-header" style="padding: 1.35rem">
              <i class="nav-icon fa fa-file-text"></i>&nbsp;
              <h5>{{ pages }}</h5>
            </div>
            <div id="divRowPageAdminPagesView" class="card-body nopadding">
              <ul class="draggable pt-1">
                <li
                  v-for="page in pageList"
                  :key="page.id"
                  class="li-menu-drag mb-2"
                  :id="'id-menu' + page.id"
                >
                  <button
                    class="btn btn-link nopadding"
                    type="button"
                    @click="setPage(false, page.id, null, 0)"
                  > 
                     <i
                      :class="page.cssIcon 
                      ? 'nav-icon fa ' + page.cssIcon + ' ' + page.cssStyle
                      : 'nav-icon fa fa-file-text-o'" 
                      data-toggle="tooltip"
                      data-placement="right"
                      :data-original-title="page.title"
                    ></i>
                    <span style="margin-right:70px">&nbsp;{{ page.title }}</span>
                  </button>
                  <div class="div-cont-rapid-icon">
                    <span v-if="!page.blocked" @click="deletePage(page.id)">
                      <i class="fa fa-trash icon-eye-menu icon-trash-menu" title="Elimina questa pagina" style="color: #bf395f!important;"></i>
                    </span>
                    <span @click="clonePage(page.id)">
                      <i
                        class="fa fa-files-o icon-eye-menu icon-trash-menu" title="Duplica questa pagina"
                      ></i>
                    </span>
                    <span
                      v-if="page.online"
                      @click="updateOnlinePage(false, page.id)"
                    >
                      <i
                        class="fa fa-eye icon-eye-menu icon-eye-menu-online" title="Clicca per offline"
                      ></i>
                    </span>
                    <span v-else @click="updateOnlinePage(true, page.id)">
                      <i
                        class="fa fa-eye-slash icon-eye-menu icon-eye-menu-offline" title="Clicca per online"
                      ></i>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          id="divContentAdminPagesView"
          class="col-sm-5 col-sm-10"
          style="transition: all 0.5s ease-in-out;margin-top:12px;"
        >
          <div class="row" v-if="titoloPagina">
            <div class="col-9" style="transition: all 0.5s ease-in-out">
              <div
                class="tab-pane active"
                role="tabpanel"
                id="pageContentAdminPagesView"
                v-if="typePage == 'Pages'"
              >
                <div class="row">
                  <FroalaEditor
                    :content="pageValueSelected.languagePageSetting.content"
                    v-on:updateContenuto="updateContenuto"
                    :tipoTemplate="tipoTemplate"
                  ></FroalaEditor>
                </div>
                <div class="row">&nbsp;</div>
                <div
                  class="row"
                  v-if="titoloPagina && typePage == 'Pages' && showJS"
                >
                  <div class="col nopadding">
                    <div
                      class="tab-pane"
                      role="tabpanel"
                      id="pageJsAdminPagesView"
                    >
                      <div class="card">
                        <div class="card-body">
                          <label>Javascript</label>
                          <codemirror
                            v-model="pageValueSelected.js"
                            :options="cmOptions"
                          ></codemirror>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="row form-group">
                  <div class="col-6 field">
                    <input v-model="linkPage.url" type="text" class="form-control inputForm" id="linkPage" required="required" name="linkPage" style="min-height: 56px;font-size: 16px;" placeholder="Link"/>
                    <label for="linkPage" class="col col-form-label nopadding label-effect">Link</label>
                  </div>
                  <div class="col-6 field">
                    <input v-model="linkPage.description" type="text" class="form-control inputForm" id="descriptionLinkPage" required="required" name="descriptionLinkPage" style="min-height: 56px;font-size: 16px;" placeholder="Descrizione"/>
                    <label for="descriptionLinkPage" class="col col-form-label nopadding label-effect">Descrizione</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3" style="transition: all 0.5s ease-in-out">
              <div
                class="tab-pane"
                role="tabpanel"
                id="pageSettingAdminPagesView"
                v-if="typePage == 'Pages'"
              >
                <div class="card">
                  <div class="card-body" style="padding: 0px 0px">
                    <div class="container-fluid nopadding">
                      <pageDetail
                        functions="AdminPages"
                        :configurations="configurationsSelected"
                        :jsonValue="pageValueSelected"
                      ></pageDetail>
                    </div>
                    <div id="accordion">
                      <div>
                        <div class="card-header" id="headingOne">
                          <i class="nav-icon fa fa-tags"></i>&nbsp;
                          <h5 class="mb-0">
                            <button
                              class="btn btn-link pl-0 ml-0"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                              aria-expanded="true"
                              aria-controls="collapseOne"
                            >
                              ATTRIBUTI
                            </button>
                          </h5>
                        </div>
                        <div
                          id="collapseOne"
                          class="collapse show"
                          aria-labelledby="headingOne"
                          data-parent="#accordion"
                        >
                          <div class="card-body">
                            <div id="pageTabAttribute">
                              <!-- v-visible="pageToView == 'settings'" -->
                              <pageDetail
                                functions="adminSettingNews"
                                :configurations="TabAttributeConfigurations"
                                :jsonValue="pageValueSelected"
                              ></pageDetail>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="card-header" id="headingTwo">
                          <i class="nav-icon fa fa-compass"></i>&nbsp;
                          <h5 class="mb-0">
                            <button
                              class="btn btn-link collapsed pl-0 ml-0"
                              data-toggle="collapse"
                              data-target="#collapseTwo"
                              aria-expanded="false"
                              aria-controls="collapseTwo"
                            >
                              PUBBLICAZIONE
                            </button>
                          </h5>
                        </div>
                        <div
                          id="collapseTwo"
                          class="collapse"
                          aria-labelledby="headingTwo"
                          data-parent="#accordion"
                        >
                          <div class="card-body">
                            <div id="pageTabPublication">
                              <!-- v-visible="pageToView == 'settings'" -->
                               <!-- select autore login utente -->
                                  <div class="row">
                                     <div class="col-12">
                                    <label>Autore</label><br>
                                    <select class="custom-select user_id" style="width:100%!important;" id="user_id" name="user_id"></select>
                                  </div>
                                </div>

                                  <!-- v-visible="pageToView == 'settings'" -->
                              <pageDetail
                                functions="adminSettingNews"
                                :configurations="TabPublicationConfigurations"
                                :jsonValue="pageValueSelected"
                              ></pageDetail>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="card-header" id="headingThree">
                          <i class="nav-icon fa fa-share-square-o"></i>&nbsp;
                          <h5 class="mb-0">
                            <button
                              class="btn btn-link collapsed pl-0 ml-0"
                              data-toggle="collapse"
                              data-target="#collapseThree"
                              aria-expanded="false"
                              aria-controls="collapseThree"
                            >
                              SOCIAL SHARE
                            </button>
                          </h5>
                        </div>
                        <div
                          id="collapseThree"
                          class="collapse"
                          aria-labelledby="headingThree"
                          data-parent="#accordion"
                        >
                          <div class="card-body">
                            <div id="pageTabSocialShare">

                          <!-- ---->  
                              <div class="row">             
                                <div class="col-12">
                                   <label class="col col-form-label nopadding label-effect" id="col-form-label">Immagine di condivisione</label>
                                  <button
                                    class="btn btn-primary mt-2"
                                    @click="getImage(pageImage)"
                                  >
                                    Seleziona
                                  </button>
                                </div>  
                                 <div class="col-12 my-2">
                                   <img style="max-width:100%; height:auto; max-height: 100px;" :src="pageValueSelected.languagePageSetting.urlCoverImage">
                                </div></div>
                        <!-- ---->
                        <!-- upload img---->  
                           <div class="row">    
                        <div class="col-12">
                        <label
                          id="move-file"
                          v-cloak
                          @drop.prevent="handleFileInput"
                          @dragover.prevent
                          class="custom-file-upload"
                          style="padding: 50px; width:100%;"
                        >
                          <input
                            id="imgAggUpload"
                            type="file"
                            name="file-input"
                            multiple="True"
                            @change="handleFileInput"
                          />
                          SFOGLIA / UPLOAD AREA
                        </label>
                      </div>
                      </div>
                    <!-- end upload img---->          



                              <!-- v-visible="pageToView == 'settings'" -->
                              <pageDetail
                                functions="adminSettingNews"
                                :configurations="TabSocialShareConfigurations"
                                :jsonValue="pageValueSelected"
                              ></pageDetail>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="card-header" id="headingFour">
                            <i class="nav-icon fa fa-cogs"></i>&nbsp;
                            <h5 class="mb-0">
                              <button
                                class="btn btn-link collapsed pl-0 ml-0"
                                data-toggle="collapse"
                                data-target="#collapseFour"
                                aria-expanded="false"
                                aria-controls="collapseFour"
                              >
                                FUNZIONALITA'
                              </button>
                            </h5>
                          </div>
                          <div
                            id="collapseFour"
                            class="collapse"
                            aria-labelledby="headingFour"
                            data-parent="#accordion"
                          >
                            <div class="card-body">
                              <div id="pageTabFunctionality">
                                <!-- v-visible="pageToView == 'settings'" -->
                                <pageDetail
                                  functions="adminSettingNews"
                                  :configurations="
                                    TabFunctionalityConfigurations
                                  "
                                  :jsonValue="pageValueSelected"
                                ></pageDetail>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
              <div v-else>
                <div class="row">
                  <div class="col-12" style="padding-top:15px;">
                    <span>Apri in una nuova schermata</span><br>
                    <label
                      class="switch switch-pill switch-primary"
                      style="margin: 2px; vertical-align: bottom"
                    >
                      <input
                        type="checkbox"
                        id="checkBox_AdminPagesView_IsTargetBlank"
                        class="switch-input"
                        v-model="linkPage.newWindow"
                      />
                     <!-- v-model="pageValueSelected.online"-->
                      <span class="switch-slider" data-on data-off></span>
                    </label>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-end" v-if="titoloPagina">
        <div class="col-6 text-right">
          <button class="btn btn-danger" @click="cancelPage">
             <i class="fa fa-times mr-1"></i>
            {{ cancel }}
          </button>
          <button class="btn btn-primary" @click="savePage(false)" v-if="typePage == 'Pages'">
          <i class="fa fa-floppy-o mr-1"></i>
            {{ save }}
          </button>
          <button class="btn btn-primary" @click="savePageLink(false)" v-else>
              <i class="fa fa-floppy-o mr-1"></i>
            {{ save }}
          </button>
          <button class="btn btn-success" @click="savePage(true)" v-if="typePage == 'Pages'">
             <i class="fa fa-floppy-o mr-1"></i>
            {{ saveAndPublish }}
          </button>
        </div>
      </div>

<!-- modal immagini -->
                  <div
                    class="modal"
                    id="modalImgBlogForm"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialo modal-dialo-pages" role="document">
                      <div class="modal-content modal">
                        <div class="modal-header text-center">
                          <div class="row" style="width:100%;">
                            <div class="col-4 text-left"> 
                              <h2 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Gestione immagini</h2>
                            </div>
                            <div class="col-2 text-right">
                              <select class="form-control" id="month" name="month" @change="Search()">
                                <option value="">Mese</option>
                                <option value="01">Gennaio</option>
                                <option value="02">Febbraio</option>
                                <option value="03">Marzo</option>
                                <option value="04">Aprile</option>
                                <option value="05">Maggio</option>
                                <option value="06">Giugno</option>
                                <option value="07">Luglio</option>
                                <option value="08">Agosto</option>
                                <option value="09">Settembre</option>
                                <option value="10">Ottobre</option>
                                <option value="11">Novembre</option>
                                <option value="12">Dicembre</option>
                              </select>
                            </div>
                            <div class="col-2 text-right">
                              <select class="form-control" id="year" name="year" @change="Search()">
                                <option value="">Anno</option>
                                <option value="2025">2025</option>
                                <option value="2024">2024</option>
                                <option value="2023">2023</option>
                                <option value="2022">2022</option>
                                <option value="2021">2021</option>
                                <option value="2020">2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                                <option value="2016">2016</option>
                                <option value="2015">2015</option>
                                <option value="2014">2014</option>
                                <option value="2013">2013</option>
                                <option value="2012">2012</option>
                                <option value="2011">2011</option>
                                <option value="2010">2010</option>
                              </select>
                            </div>
                            <div class="col-4"> 
                              <input type="text" class="form-control" id="search" required="required" name="search" placeholder="Cerca" @keyup="Search()"/> 
                            </div>
                          </div>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"

                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body mx-3">
                          <div class="md-form mb-5">
                            <div
                              class="row">
                             <ul class="list-group" id="ul-image" @scroll="handleScroll">
                              <li class="listLi" v-for="resultFilePopup in resultFilePopups" v-bind:key="resultFilePopup.id" @click="
                                selectImg(
                                resultFilePopup.img,
                                resultFilePopup.imgName)" >
                                <div class="list-group-item" v-if="resultFilePopup.visible" :style="'cursor:pointer;position: relative;min-width:110px;min-height:110px;min-width:110px;max-width:110px;background-size:cover;background-image:url(\'' + resultFilePopup.img + '\')'">
                                  <div v-if="resultFilePopup.ext!=''" class="div-extension-img">
                                    <label>{{ resultFilePopup.ext }}</label>
                                  </div>
                                  <label class="labelListImage">{{ resultFilePopup.imgName }}</label>
                                </div>
                                </li> 
                            </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end modal immagini -->

      <div class="row">&nbsp;</div>
    </div>
    <div
      class="modal fade"
      id="modalAskCopyAll"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-primary" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalAskCopyTitle">
              {{ modalAskCopyTitle }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row" id="divModalAskCopyContent">
                <label class="col-8 col-form-label">{{
                  modalAskCopyContent
                }}</label>
                <div>
                  <label
                    class="switch switch-pill switch-primary"
                    style="margin: 2px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      class="switch-input"
                      id="chkModalAskCopyContent"
                    />
                    <span class="switch-slider" data-on data-off></span>
                  </label>
                </div>
              </div>
              <div class="row" id="divModalAskCopySetting">
                <label class="col-8 col-form-label">{{
                  modalAskCopySetting
                }}</label>
                <div>
                  <label
                    class="switch switch-pill switch-primary"
                    style="margin: 2px; vertical-align: bottom"
                  >
                    <input
                      type="checkbox"
                      class="switch-input"
                      id="chkModalAskCopySetting"
                    />
                    <span class="switch-slider" data-on data-off></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ cancel }}
            </button>
            <button type="button" class="btn btn-primary">{{ save }}</button>
          </div>
        </div>
      </div>
    </div>
    <!--Modal esegui modifica traduzioni DetailTranslation-->
    <div
      class="modal"
      id="modalPageSpeedTest"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content padding">
          <div class="modal-header text-center">
            <h4 class="modal-title w-100 font-weight-bold">
              Analisi pagina
            </h4>
          </div>
          <div class="modal-body mx-12">
            <div class="md-form mb-12">
              <div class="row" v-if="dataPageSpeedEmpty">
                <div class="col-12 text-center">
                  <i class="fa fa-cog fa-spin fa-3x"></i><br>
                  <span style="color:#3C4B64">Acquisizione dati...</span>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-12">
                  <div class="row">
                    <div class="col-6 text-center">
                      <h4>Mobile</h4>
                      <h1 :class="classMobileTitle" style="font-weight:bold;font-size:70px;">{{dataPageSpeedMobile}}</h1><br>
                      <div class="meter">
                        <span :class="classMobileProgressBar" :style="'width:' + dataPageSpeedMobile + '%'"></span>
                      </div><br><br>
                      <img :src="dataPageSpeedMobileImg" style="width:50%;">
                    </div>
                    <div class="col-6 text-center">
                      <h4>Desktop</h4>
                      <h1 :class="classTitle" style="font-weight:bold;font-size:70px;">{{dataPageSpeed}}</h1><br>
                      <div class="meter">
                        <span :class="classProgressBar" :style="'width:' + dataPageSpeed + '%'"></span>
                      </div><br><br>
                      <img :src="dataPageSpeedImg" style="width:50%;">
                      <hr>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 text-center">
                      <h3>{{dataPageSpeedId}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end modal traduzioni -->
  </div>
</template>

<script>
import Select2 from "@/components/Select2.vue";
import PageDetail from "@/components/PageDetail.vue";
import MenuDraggable from "@/components/MenuDraggable.vue";
import FroalaEditor from "@/components/FroalaEditor.vue";
import { codemirror } from "vue-codemirror";
/*import "codemirror/lib/codemirror.css";
import 'codemirror/mode/xml/xml.js';*/

import 'codemirror/mode/javascript/javascript.js'
  // theme css
  import 'codemirror/theme/monokai.css'
  // require active-line.js
  import'codemirror/addon/selection/active-line.js'
  // styleSelectedText
  import'codemirror/addon/selection/mark-selection.js'
  import'codemirror/addon/search/searchcursor.js'
  // hint
  import'codemirror/addon/hint/show-hint.js'
  import'codemirror/addon/hint/show-hint.css'
  import'codemirror/addon/hint/javascript-hint.js'
  import'codemirror/addon/selection/active-line.js'
  // highlightSelectionMatches
  import'codemirror/addon/scroll/annotatescrollbar.js'
  import'codemirror/addon/search/matchesonscrollbar.js'
  import'codemirror/addon/search/searchcursor.js'
  import'codemirror/addon/search/match-highlighter.js'
  // keyMap
  import'codemirror/mode/clike/clike.js'
  import'codemirror/addon/edit/matchbrackets.js'
  import'codemirror/addon/comment/comment.js'
  import'codemirror/addon/dialog/dialog.js'
  import'codemirror/addon/dialog/dialog.css'
  import'codemirror/addon/search/searchcursor.js'
  import'codemirror/addon/search/search.js'
  import'codemirror/keymap/sublime.js'
  // foldGutter
  import'codemirror/addon/fold/foldgutter.css'
  import'codemirror/addon/fold/brace-fold.js'
  import'codemirror/addon/fold/comment-fold.js'
  import'codemirror/addon/fold/foldcode.js'
  import'codemirror/addon/fold/foldgutter.js'
  import'codemirror/addon/fold/indent-fold.js'
  import'codemirror/addon/fold/markdown-fold.js'
  import'codemirror/addon/fold/xml-fold.js'
  

export default {
  name: "adminPages",
  components: {
    codemirror,
    Select2,
    PageDetail,
    MenuDraggable,
    FroalaEditor
  },
  data: function() {
    return {
          cmOptions: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          styleSelectedText: false,
          line: true,
          foldGutter: true,
          gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
          highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
          mode: 'text/javascript',
          // hint.js options
          hintOptions:{
            completeSingle: false
          },

          keyMap: "sublime",
          matchBrackets: true,
          showCursorWhenSelecting: true,
          theme: "default",
          extraKeys: { "Ctrl": "autocomplete" }
        },
      
    /*  cmOptions: {
        indentWithTabs: true,
        line: true,
        lineNumbers: true,
        lineWrapping: true,
        mode: "text/css",
        tabMode: "indent",
        theme:'default',
        tabSize: 4
      },*/
      isLink: false,
      facebookTrackId: "",
      divLanguage: false,
      pageToView: "content",
      tipoTemplate: "Pages",
      titoloPagina: "",
      typePage: "",
      configurations: {},
      files: [],
      resultFilePopups: [],
      configurationsSettings: [],
      configurationsFolders: [],
      configurationsLink: [],
      configurationsSelected: [],
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null, imgName:null, imgNameShare: null},
        online: false
      },
      linkPage: {
        id: '',
        url: '',
        description: '',
        newWindow: false,
        hideMobile: false,
        idLanguage: ''
      },
      pageValueOriginal: {},
      pageValueDataToSave: {},
      defaultLanguage: 0,
      defaultLanguageOptions: [],
      allLanguageOptions: [],
      menuList: [],
      pageList: [],
      TabAttributeConfigurations: [],
      TabPublicationConfigurations: [],
      TabSocialShareConfigurations: [],
      TabFunctionalityConfigurations: [],
      showJS: false,
      lastIdMenu: 0,
      lastIdPage: 0,
      showBtnContentAdminPagesView: true,
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      content: dictionaryHelpers.getDictionary("Content"),
      language: dictionaryHelpers.getDictionary("Language"),
      menu: dictionaryHelpers.getDictionary("Menu"),
      modalAskCopyContent: dictionaryHelpers.getDictionary(
        "ModalAskCopyContent"
      ),
      modalAskCopySetting: dictionaryHelpers.getDictionary(
        "ModalAskCopySetting"
      ),
      modalAskCopyTitle: dictionaryHelpers.getDictionary("ModalAskCopyTitle"),
      newPage: dictionaryHelpers.getDictionary("NewPage"),
      newLink: dictionaryHelpers.getDictionary("NewLink"),
      newFolder: dictionaryHelpers.getDictionary("NewFolder"),
      online: dictionaryHelpers.getDictionary("Online"),
      pages: dictionaryHelpers.getDictionary("Pages"),
      pageSetting: dictionaryHelpers.getDictionary("PageSetting"),
      preview: dictionaryHelpers.getDictionary("Preview"),
      save: dictionaryHelpers.getDictionary("Save"),
      saveAndPublish: dictionaryHelpers.getDictionary("SaveAndPublish"),
      url: window.location.pathname,
      dataPageSpeed: {},
      dataPageSpeedMobile: {},
      dataPageSpeedEmpty: true,
      classTitle: '',
      classProgressBar: '',
      classMobileTitle: '',
      classMobileProgressBar: '',
      dataPageSpeedImg: '',
      img:'',
      name: '',
      visible:true,
      pageImage: 1,
      dataPageSpeedMobileImg: ''
    };
  },

  created() {
    spinnerHelpers.show();
    var adminPages = this;

    settingServices.getByCode("FacebookTrackId", function(result) {
      /* Inizializzazione FB Plugin */
      window.fbAsyncInit = function() {
        FB.init({
          appId: "2637631553029441",
          autoLogAppEvents: true,
          xfbml: true,
          version: "v6.0"
        });
      };

      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/all.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
      /* end inizializzazione FB plugin */
    });

    adminPages.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };
    languageServices.select("*", function(result) {
      adminPages.allLanguageOptions = result.data;
    });

    adminConfigurationServices.getFunctionality(function(result) {
      if ( functionHelpers.isValued(result) && functionHelpers.isValued(result.data) && functionHelpers.isValued(result.data) ) {
        adminPages.configurations = result.data;
        $.each(adminPages.configurations.tabsConfigurations, function(i, configuration) {
          switch (configuration.code) {
            case "Settings":
              adminPages.configurationsSettings = configuration.pageConfigurations;
              break;
            case "Link":
              adminPages.configurationsLink = configuration.pageConfigurations;
              break;
            case "Folder":
              adminPages.configurationsFolders = configuration.pageConfigurations;
              break;
            case "TabAttribute":
              adminPages.TabAttributeConfigurations = configuration.pageConfigurations;
              break;
            case "TabPublication":
              adminPages.TabPublicationConfigurations = configuration.pageConfigurations;
              break;
            case "TabSocialShare":
              adminPages.TabSocialShareConfigurations = configuration.pageConfigurations;
              break;
            case "TabFunctionality":
              adminPages.TabFunctionalityConfigurations = configuration.pageConfigurations;
              break;
          }
        });

        $.each(adminPages.configurationsSettings, function(i, config) {
          if (config.field == "pageType") {
            adminPages.pageValueSelected.pageType = config.defaultValue;
            adminPages.pageValueOriginal.pageType = config.defaultValue;
          }
        });
        adminPages.changeView("btnContentAdminPagesView");
        //adminPages.$refs.btnContentAdminPagesView.click();
      }
    });

    adminPages.refreshList();
  },
  mounted() {
    var adminPages = this;

    languageServices.select("*", function(result) {
      if (result.data.length == 1) {
        adminPages.divLanguage = false;
      } else {
        adminPages.divLanguage = true;
      }
    });
  },
  watch: {
    "pageValueSelected.enableJS": function(newVal, oldVal) {
      this.showJS = newVal;
    }
  },
  methods: {
    sharepage() {},
    previewClick() {
      window.open(this.pageValueSelected.languagePageSetting.url + '_preview');
    },
    testPageClick(){
      var adminPages = this;
      adminPages.dataPageSpeedEmpty = true;
      $('#modalPageSpeedTest').modal('show');
      
      var urlPageTest = configData.wsRootServicesUrl.replace('/api','') + this.pageValueSelected.languagePageSetting.url;
      
      var API_URL = 'https://www.googleapis.com/pagespeedonline/v5/runPagespeed?';
      var API_KEY = 'AIzaSyDHixX_-Zssz2iVPfApBtt506IxHQ79Yww';
      var query = [
        'url=' + urlPageTest,
        'key=' + API_KEY,
        'strategy=desktop',
        'locale=it',
      ].join('&');


      $.ajax({
        type: "GET",
        url: API_URL + query,
        success: function(data){
          adminPages.dataPageSpeed = data.lighthouseResult.categories.performance.score * 100;
          adminPages.dataPageSpeedId = data.id;
          adminPages.dataPageSpeedImg = data.lighthouseResult.audits['final-screenshot'].details.data;

          if(adminPages.dataPageSpeed  >= 90){
              adminPages.classTitle = "greenTitle";
              adminPages.classProgressBar = "greenBkg";
          }else if(adminPages.dataPageSpeed >= 50 && adminPages.dataPageSpeed < 90){
              adminPages.classTitle = "orangeTitle";
              adminPages.classProgressBar = "orangeBkg";
          }else if(adminPages.dataPageSpeed >= 0 && adminPages.dataPageSpeed < 50){
              adminPages.classTitle = "redTitle";
              adminPages.classProgressBar = "redBkg";
          }        
        },
        error: function(data) {
          spinnerHelpers.hide();
        }
      });

      var queryMobile = [
        'url=' + urlPageTest,
        'key=' + API_KEY,
        'strategy=mobile',
        'locale=it',
      ].join('&');
      $.ajax({
        type: "GET",
        url: API_URL + queryMobile,
        success: function(data){

          adminPages.dataPageSpeedEmpty = false;
          adminPages.dataPageSpeedMobile = data.lighthouseResult.categories.performance.score * 100;
          adminPages.dataPageSpeedId = data.id;
          adminPages.dataPageSpeedMobileImg = data.lighthouseResult.audits['final-screenshot'].details.data;
          if(adminPages.dataPageSpeedMobile  >= 90){
              adminPages.classMobileTitle = "greenTitle";
              adminPages.classMobileProgressBar = "greenBkg";
          }else if(adminPages.dataPageSpeedMobile >= 50 && adminPages.dataPageSpeedMobile < 90){
              adminPages.classMobileTitle = "orangeTitle";
              adminPages.classMobileProgressBar = "orangeBkg";
          }else if(adminPages.dataPageSpeedMobile >= 0 && adminPages.dataPageSpeedMobile < 50){
              adminPages.classMobileTitle = "redTitle";
              adminPages.classMobileProgressBar = "redBkg";
          }
        },
        error: function(data) {
          spinnerHelpers.hide();
        }
      });
    },
    refreshList(idLang) {
      var adminPages = this;
      if (idLang == "" || idLang === undefined) {
        idLang = storageData.sIdLanguage();
      }
      var pageTypeList = adminPages.pageValueSelected.pageType;
      pageServices.getMenuList(idLang, pageTypeList, function(result) {
        adminPages.menuList = result.data.menuList;
        adminPages.pageList = result.data.pageList;
        spinnerHelpers.hide();
      });
    },

    getValue(set) {
      var adminPages = this;
      $.each(adminPages.configurationsSelected, function(i, config) {
        if (functionHelpers.isValued(config.field)) {
          if (!functionHelpers.isValued(adminPages.pageValueSelected[config.field.split(".")[0]]) || set) {
            if (config.field.split(".").length > 1) {
              adminPages.pageValueSelected[config.field.split(".")[0]] = {};
            } else {
              adminPages.pageValueSelected[config.field.split(".")[0]] = null;
            }
          }

          if (config.field.split(".").length > 1) {
            if (
              !functionHelpers.isValued(
                adminPages.pageValueSelected[config.field.split(".")[0]][
                  config.field.split(".")[1]
                ]
              ) ||
              set
            ) {
              adminPages.pageValueSelected[config.field.split(".")[0]][
                config.field.split(".")[1]
              ] = null;
            }
          }
        }
      });
      if (
        !functionHelpers.isValued(
          adminPages.pageValueSelected.languagePageSetting.content
        ) ||
        set
      ) {
        adminPages.pageValueSelected.languagePageSetting.content = "";
      }

      if (set) {
        adminPages.pageValueSelected.id = null;
        adminPages.pageValueSelected.online = null;
      }
    },

      handleFileInput(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (var i = 0; i < files.length; i++) {
        this.createImgAgg(e.target.id, files[i].name, files[i]);
      }
    },

  createImgAgg(id, name, file) {
      var adminPages = this;
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        var jsonImgUpload = {};
        jsonImgUpload["id"] = adminPages.cont + 1;
        adminPages.cont = adminPages.cont + 1;
        jsonImgUpload["name"] = name;
        jsonImgUpload["size"] = "0";
        jsonImgUpload["base64"] = e.target.result;
        adminPages.pageValueSelected.languagePageSetting.imgName = name;
        adminPages.pageValueSelected.languagePageSetting.urlCoverImage =  e.target.result;
        adminPages.pageValueSelected.languagePageSetting.imgNameShare = name;
        adminPages.pageValueSelected.languagePageSetting.urlShareImage =  e.target.result;
        adminPages.files.push(jsonImgUpload);
      };
      reader.readAsDataURL(file);
    },

    changeViewLink: function(event) {
      var adminPages = this;
      adminPages.typePage = "Link";
      this.pageValueDataToSave = [];
      var id = event && event.target && event.target.id ? event.target.id : "";
      switch (id) {
        case "btnNewLinkAdminPagesView":
          adminPages.typePage = "Link";
          adminPages.linkPage = {
            id: '',
            url: '',
            description: '',
            newWindow: false,
            hideMobile: false,
            idLanguage: ''
          };
          adminPages.pageValueSelected.languagePageSetting.idLanguage = storageData.sIdLanguage();
          this.titoloPagina = " ";
          break;
        default:
          adminPages.typePage = "Link";
          adminPages.pageValueSelected.languagePageSetting.idLanguage = storageData.sIdLanguage();
          this.titoloPagina = " ";
          break;

      }
    },

    changeView: function(event) {
      var adminPages = this;
      var id = event && event.target && event.target.id ? event.target.id : "";
      this.pageValueDataToSave = [];
      switch (id) {
        case "btnNewPageAdminPagesView":
          adminPages.pageToView = "content";
          adminPages.typePage = "Pages";
          adminPages.configurationsSelected = adminPages.configurationsSettings;
          adminPages.showBtnContentAdminPagesView = true;
          adminPages.pageValueSelected.enableJS= false;
          adminPages.pageValueSelected.js= "";
   
          /*if (adminPages.$refs.btnContentAdminPagesView) {
            adminPages.$refs.btnContentAdminPagesView.classList = "btn btn-info active";
          }
          adminPages.$refs.btnSettingAdminPagesView.classList = "btn btn-outline-dark-bk-white";*/
          this.getValue(true);
          adminPages.pageValueSelected.languagePageSetting.idLanguage = storageData.sIdLanguage();
          this.titoloPagina = " ";
          $('#languagePageSetting_seoTitle_feedback').remove();
          $('#languagePageSetting_seoDescription_feedback').remove();
         // $('#languagePageSetting_SeoKeyword_feedback').remove();

            setTimeout(function() { 
                if ($('#languagePageSetting_seoTitle').val() == ''){
                  $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>');
                  $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>');
                }
         /* if ($('#languagePageSetting_SeoKeyword').val() == ''){      
            $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>');
          }*/

            }, 100);
          break;

        case "btnNewLinkAdminPagesView":
          adminPages.pageToView = "settings";
          adminPages.typePage = "Link";
          adminPages.configurationsSelected = adminPages.configurationsLink;
          adminPages.showBtnContentAdminPagesView = false;
          /*adminPages.$refs.btnSettingAdminPagesView.classList = "btn btn-info active";*/
          this.getValue(true);
          adminPages.pageValueSelected.languagePageSetting.idLanguage = storageData.sIdLanguage();
          this.titoloPagina = " ";
          break;

        case "btnNewFolderAdminPagesView":
          adminPages.pageToView = "settings";
          adminPages.typePage = "Folder";
          adminPages.configurationsSelected = adminPages.configurationsFolders;
          adminPages.showBtnContentAdminPagesView = false;
          /*adminPages.$refs.btnSettingAdminPagesView.classList = "btn btn-info active";*/
          this.getValue(true);
          adminPages.pageValueSelected.languagePageSetting.idLanguage = storageData.sIdLanguage();
          this.titoloPagina = " ";
          break;

        case "btnSettingAdminPagesView":
          adminPages.pageToView = "settings";
          adminPages.typePage = "Setting";
          adminPages.configurationsSelected = adminPages.configurationsSettings;
          adminPages.showBtnContentAdminPagesView = true;
          /*adminPages.$refs.btnContentAdminPagesView.classList = "btn btn-outline-dark-bk-white";
          adminPages.$refs.btnSettingAdminPagesView.classList = "btn btn-info active";*/
          this.getValue(false);
          adminPages.pageValueSelected.languagePageSetting.idLanguage = storageData.sIdLanguage();
          break;

        default:

          adminPages.pageToView = "content";
          adminPages.typePage = "Pages";
          adminPages.configurationsSelected = adminPages.configurationsSettings;
          adminPages.showBtnContentAdminPagesView = true;
          /*  adminPages.$refs.btnContentAdminPagesView.classList = "btn btn-info active";
          adminPages.$refs.btnSettingAdminPagesView.classList = "btn btn-outline-dark-bk-white";*/
          this.getValue(false);
          adminPages.pageValueSelected.languagePageSetting.idLanguage = storageData.sIdLanguage();

          $('#languagePageSetting_seoTitle_feedback').remove();
          $('#languagePageSetting_seoDescription_feedback').remove();
         // $('#languagePageSetting_SeoKeyword_feedback').remove();


          setTimeout(function() { 
              if ($('#languagePageSetting_seoTitle').val() == ''){
                $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>');
                $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>');
               // $('#languagePageSetting_SeoKeyword').before('<div id="languagePageSetting_SeoKeyword_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>');

              }       
          }, 100);
          break;

      }

      $.each(adminPages.configurationsSelected, function(i, config) {
        if (config.field == "pageType") {
          adminPages.pageValueSelected.pageType = config.defaultValue;
          adminPages.pageValueOriginal.pageType = config.defaultValue;
        }
      });

      var sUserId = storageData.sUserId();
      pageServices.getByUserDescription(sUserId, function(result){

     $.getScript( "https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js").done(function () {
      var searchParam = "";
      var initials = [];
      initials.push({
        id: result.data.idUser,
        text: result.data.userName
      });
      $('#user_id').select2({
        data: initials,
        ajax: {
          url: configData.wsRootServicesUrl + "/api/v1/user/selectUserPages",
          data: function (params) {
            if(params.term==''){
              searchParam = '*';
            }else{
              searchParam = params.term;
            }

            var query = {
              search: searchParam
            }
            return query;
          },
          processResults: function (data) {
            var dataParse = JSON.parse(data);
            return {
              results: dataParse.data
            };
          }
        }
      });
    });
  });

    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminPages = this;

      if (
        functionHelpers.isValued(adminPages.pageValueSelected) &&
        adminPages.pageValueSelected.languagePageSetting.idLanguage != value
      ) {
        // Save data
        var languageFound = false;
        $.each(adminPages.pageValueDataToSave, function(i, dataToSave) {
          switch (adminPages.typePage) {
            case "Link":
            case "Folder":
              if (
                dataToSave.idLanguage ==
                  adminPages.pageValueSelected.languagesMenus.idLanguage &&
                functionHelpers.isValued(
                  adminPages.pageValueSelected.languagesMenus.idLanguage
                )
              ) {
                adminPages.pageValueDataToSave[i] = dataHelpers.unbind(
                  adminPages.pageValueSelected.languagesMenus
                );
                languageFound = true;
              }
              break;
            case "Pages":
            default:
              if (
                dataToSave.idLanguage ==
                adminPages.pageValueSelected.languagePageSetting.idLanguage
              ) {
                adminPages.pageValueDataToSave[i] = dataHelpers.unbind(
                  adminPages.pageValueSelected.languagePageSetting
                );
                languageFound = true;
              }
              break;
          }
        });

        if (!languageFound) {
          switch (adminPages.typePage) {
            case "Link":
            case "Folder":
              var i = 0;
              if (
                functionHelpers.isValued(adminPages.pageValueDataToSave.length)
              ) {
                i = adminPages.pageValueDataToSave.length;
              }
              adminPages.pageValueDataToSave[i] = dataHelpers.unbind(
                adminPages.pageValueSelected.languagesMenus
              );
              adminPages.pageValueDataToSave[i][
                "idLanguage"
              ] = dataHelpers.unbind(
                adminPages.pageValueSelected.languagesMenus.idLanguage
              );
              break;
            case "Pages":
            default:
              var i = 0;
              if (
                functionHelpers.isValued(adminPages.pageValueDataToSave.length)
              ) {
                i = adminPages.pageValueDataToSave.length;
              }
              adminPages.pageValueDataToSave[i] = dataHelpers.unbind(
                adminPages.pageValueSelected.languagePageSetting
              );
              break;
          }
        }

        languageFound = false;
        // Set data from save data
        $.each(adminPages.pageValueDataToSave, function(i, dataToSave) {
          switch (adminPages.typePage) {
            case "Link":
            case "Folder":
              if (dataToSave.idLanguage == value) {
                adminPages.pageValueSelected.languagesMenus = dataHelpers.unbind(
                  dataToSave
                );
                languageFound = true;
              }
              break;
            case "Pages":
            default:
              if (dataToSave.idLanguage == value) {
                adminPages.pageValueSelected.languagePageSetting = dataHelpers.unbind(
                  dataToSave
                );
                languageFound = true;
              }
              break;
          }
        });

        if (!languageFound) {
          switch (adminPages.typePage) {
            case "Link":
            case "Folder":
              $.each(adminPages.pageValueSelected.languagesMenus, function(
                fieldKey,
                fieldValue
              ) {
                switch (fieldKey) {
                  case "idLanguage":
                    adminPages.pageValueSelected.languagesMenus[
                      fieldKey
                    ] = Number(value);
                    break;

                  default:
                    adminPages.pageValueSelected.languagesMenus[
                      fieldKey
                    ] = null;
                    break;
                }
              });
              break;
            case "Pages":
            default:
              $.each(adminPages.pageValueSelected.languagePageSetting, function(
                fieldKey,
                fieldValue
              ) {
                switch (fieldKey) {
                  case "idLanguage":
                    adminPages.pageValueSelected.languagePageSetting[
                      fieldKey
                    ] = Number(value);
                    break;

                  default:
                    adminPages.pageValueSelected.languagePageSetting[
                      fieldKey
                    ] = null;
                    break;
                }
              });
              break;
          }
        }
      }
      var pageTypeList = adminPages.pageValueSelected.pageType;
      pageServices.getMenuList(value, pageTypeList, function(result) {
        adminPages.menuList = result.data.menuList;
        adminPages.pageList = result.data.pageList;
      });
      spinnerHelpers.hide();
    },
    setPage(isMenuWeb, id, idMenu, menuType) {
      spinnerHelpers.show();
      var adminPages = this;
      if(menuType == 'Link'){
        menuType = 1;
      }
      switch (menuType) {
        case 1:
          adminPages.changeViewLink();
          adminPages.typePage = "Link";
            var sUserId = storageData.sUserId();
            pageServices.getSetting(id,sUserId, function(result) {
              
              adminPages.linkPage.id = result.data.id;
              adminPages.linkPage.url = result.data.languagePageSetting[0].url;
              adminPages.linkPage.description = result.data.languagePageSetting[0].title;
              adminPages.linkPage.newWindow = result.data.newWindow;
              adminPages.linkPage.idLanguage = result.data.languagePageSetting[0].idLanguage;
              $("html, body").animate({ scrollTop: 0 }, "slow");
            });
          break;
        case 2:
          adminPages.changeView();
          adminPages.typePage = "Folder";
          menuServices.getSettings(idMenu, function(result) {
            adminPages.pageValueOriginal = dataHelpers.unbind(result.data);
            adminPages.pageValueDataToSave = dataHelpers.unbind(
              result.data.languagesMenus
            );
            adminPages.titoloPagina = result.data.languagesMenus[0].title;
            adminPages.setDataPage(dataHelpers.unbind(result.data));
          });
          break;
        default:
          adminPages.changeView('btnNewPageAdminPagesView');
          adminPages.typePage = "Pages";
          var sUserId = storageData.sUserId();
          pageServices.getSetting(id,sUserId, function(result) {
            adminPages.pageValueOriginal = dataHelpers.unbind(result.data);
            adminPages.pageValueDataToSave = dataHelpers.unbind(
              result.data.languagePageSetting
            );
            adminPages.titoloPagina = result.data.languagePageSetting[0].title;
            adminPages.setDataPage(dataHelpers.unbind(result.data));

  $.getScript("https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js").done(function(){ 
      var searchParam = ""; 
        var initials = [];
  // if (result.data.idUser != 'null' || result.data.idUser != null || result.data.idUser != '') { 
        initials.push({
          id: result.data.idUser,
          text: result.data.userName
        });
    //}  
        $('#user_id').select2({
          data: initials,
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/user/selectUserPages",
            data: function (params) {
              if(params.term==''){
                searchParam = '*';
              }else{
              searchParam = params.term;  
              }                      
              var query = {
              search: searchParam 
              }          
              return query;        
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);        
              return {
                results: dataParse.data
              };  
            }
          }
        });


      var searchParam = ""; 
        var initials = [];
        $('#user_id').select2({
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/user/selectUserPages",
            data: function (params) {
              if(params.term==''){
                searchParam = '*';
              }else{
              searchParam = params.term;  
              }                      
              var query = {
              search: searchParam 
              }          
              return query;        
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);        
              return {
                results: dataParse.data
              };  
            }
          }
        });
    });   
 });
 break;
    }
    $(".li-menu-drag").removeClass("activeMenu");
    $("#id-menu" + id).addClass("activeMenu");
    spinnerHelpers.hide();
    },

    setDataPage(data) {

      var adminPages = this;
      console.log(adminPages.typePage);
      adminPages.pageValueSelected = data;
      adminPages.img = data.languagePageSetting.urlCoverImage;

      switch (adminPages.typePage) {
        case "Folder":
        case "Link":
          $.each(
            dataHelpers.unbind(adminPages.pageValueOriginal.languagesMenus),
            function(i, languagesMenus) {
              if ((adminPages.$refs.select_AdminPagesView_IdLanguage === undefined && languagesMenus.idLanguage == storageData.sIdLanguage()) || 
              languagesMenus.idLanguage == adminPages.$refs.select_AdminPagesView_IdLanguage.value) {
                adminPages.pageValueSelected.languagesMenus = languagesMenus;
                adminPages.pageValueSelected.languagePageSetting = languagesMenus;

                adminPages.pageToView = "settings";
                adminPages.configurationsSelected = adminPages.configurationsLink;
                adminPages.showBtnContentAdminPagesView = false;
                adminPages.$refs.btnSettingAdminPagesView.classList = "btn btn-info active";
                return;
              }
            }
          );
          break;
        case "Pages":
          setTimeout(function() { 
            var SeotitleToTitles= adminPages.pageValueSelected.languagePageSetting.seoTitle;
            if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
                var d = ((87 * 10)/100) + "%";
                $('#languagePageSetting_seoTitle_feedback').remove();
                $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
            }else{
              if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
                var d = ((87 * SeotitleToTitles.length)/30) + "%";
                $('#languagePageSetting_seoTitle_feedback').remove();
                $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom:15px;left: 13px;"></div>')
              }
              if (SeotitleToTitles.length > 30 && SeotitleToTitles.length <= 60){
                  var d = ((87 * SeotitleToTitles.length)/60) + "%";
                  $('#languagePageSetting_seoTitle_feedback').remove();
                  $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
              }
              if (SeotitleToTitles.length > 60 && SeotitleToTitles.length <= 1000){
                  var d = ((87 * SeotitleToTitles.length)/1000) + "%";
                  $('#languagePageSetting_seoTitle_feedback').remove();
                  $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
              }
            }

            var seoDescriptiontoShareDescription = adminPages.pageValueSelected.languagePageSetting.seoDescription;
            if (seoDescriptiontoShareDescription == '' || seoDescriptiontoShareDescription == null || seoDescriptiontoShareDescription == 'null' || seoDescriptiontoShareDescription == 0) {
              var d = ((87 * 10)/100) + "%";
                $('#languagePageSetting_seoDescription_feedback').remove();
                $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
            }else{
              if (seoDescriptiontoShareDescription.length >= 0 && seoDescriptiontoShareDescription.length <= 70){
                  var d = ((87 * seoDescriptiontoShareDescription.length)/70) + "%";
                  $('#languagePageSetting_seoDescription_feedback').remove();
                  $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
              }

              if (seoDescriptiontoShareDescription.length > 70 && seoDescriptiontoShareDescription.length <= 155){
                  var d = ((87 * seoDescriptiontoShareDescription.length)/155) + "%";
                  $('#languagePageSetting_seoDescription_feedback').remove();
                  $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -126px;left: 13px;"></div>')
              }

              if (seoDescriptiontoShareDescription.length > 155 && seoDescriptiontoShareDescription.length <= 2000){
                  var d = ((87 * seoDescriptiontoShareDescription.length)/2000) + "%";
                  $('#languagePageSetting_seoDescription_feedback').remove();
                  $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -126px;left: 13px;"></div>')
              }
            }

          }, 100);
        default:
          $.each( dataHelpers.unbind( adminPages.pageValueOriginal.languagePageSetting ), function(i, languagePageSetting) {
              if (
                (adminPages.$refs.select_AdminPagesView_IdLanguage === undefined && languagePageSetting.idLanguage == storageData.sIdLanguage()) || languagePageSetting.idLanguage ==
                adminPages.$refs.select_AdminPagesView_IdLanguage.value) {
                adminPages.pageValueSelected.languagePageSetting = languagePageSetting;
  
                setTimeout(function() {
                  var SeotitleToTitles= languagePageSetting.seoTitle;
                  if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
                      var d = ((87 * 10)/100) + "%";
                      $('#languagePageSetting_seoTitle_feedback').remove();
                      $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
                  }else{
                    if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
                      var d = ((87 * SeotitleToTitles.length)/30) + "%";
                      $('#languagePageSetting_seoTitle_feedback').remove();
                      $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom:15px;left: 13px;"></div>')
                    }
                    if (SeotitleToTitles.length > 30 && SeotitleToTitles.length <= 60){
                        var d = ((87 * SeotitleToTitles.length)/60) + "%";
                        $('#languagePageSetting_seoTitle_feedback').remove();
                        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
                    }
                    if (SeotitleToTitles.length > 60 && SeotitleToTitles.length <= 1000){
                        var d = ((87 * SeotitleToTitles.length)/1000) + "%";
                        $('#languagePageSetting_seoTitle_feedback').remove();
                        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
                    }
                  }

                  var seoDescriptiontoShareDescription = languagePageSetting.seoDescription;

                  if (seoDescriptiontoShareDescription == '' || seoDescriptiontoShareDescription == null || seoDescriptiontoShareDescription == 'null' || seoDescriptiontoShareDescription == 0) {
                    var d = ((87 * 10)/100) + "%";
                      $('#languagePageSetting_seoDescription_feedback').remove();
                      $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
                  }else{
                    if (seoDescriptiontoShareDescription.length >= 0 && seoDescriptiontoShareDescription.length <= 70){
                        var d = ((87 * seoDescriptiontoShareDescription.length)/70) + "%";
                        $('#languagePageSetting_seoDescription_feedback').remove();
                        $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
                    }

                    if (seoDescriptiontoShareDescription.length > 70 && seoDescriptiontoShareDescription.length <= 155){
                        var d = ((87 * seoDescriptiontoShareDescription.length)/155) + "%";
                        $('#languagePageSetting_seoDescription_feedback').remove();
                        $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -126px;left: 13px;"></div>')
                    }

                    if (seoDescriptiontoShareDescription.length > 155 && seoDescriptiontoShareDescription.length <= 2000){
                        var d = ((87 * seoDescriptiontoShareDescription.length)/2000) + "%";
                        $('#languagePageSetting_seoDescription_feedback').remove();
                        $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -126px;left: 13px;"></div>')
                    } 
                  }

                }, 100);
                return;
              }
            }
          );
          break;
      }
       $("html, body").animate({ scrollTop: 0 }, "slow");
      spinnerHelpers.hide();
    },

    getFieldType(field) {
      var adminPages = this;
      var result;

      $.each(adminPages.configurationsSelected, function(i, config) {
        if (config.field == field) {
          result = config.inputType;
          return false;
        }
      });

      return result;
    },
    cancelPage() {
      spinnerHelpers.show();
      var adminPages = this;
      if (functionHelpers.isValued(adminPages.pageValueOriginal.languagePageSetting)) {
        adminPages.pageValueDataToSave = dataHelpers.unbind(adminPages.pageValueOriginal.languagePageSetting);
        adminPages.setDataPage(adminPages.pageValueOriginal);
      } else {
        adminPages.getValue(true);
        spinnerHelpers.hide();
      }
      window.scrollTo(0, 0);
      notificationHelpers.success(
        dictionaryHelpers.getDictionary("CancelNotification")
      );
    },
    savePageLink(publish){
      spinnerHelpers.show();
      var adminPages = this;
      adminPages.linkPage.idLanguage = adminPages.$refs.select_AdminPagesView_IdLanguage.value;
      var dataToSave = adminPages.linkPage;
      if(adminPages.linkPage.id == ''){       
        menuServices.insertNewLink(dataToSave, function(result) {
          notificationHelpers.success(dictionaryHelpers.getDictionary("InsertCompleted"));
          adminPages.refreshList(adminPages.$refs.select_AdminPagesView_IdLanguage.value);
          //adminPages.setPage(!dataToSave.hideMenu,result.data,result.data,1);
          window.scrollTo(0, 0);
        });
      }else{
        menuServices.updateNewLink(dataToSave, function(result) {
          notificationHelpers.success(dictionaryHelpers.getDictionary("UpdateCompleted"));
          adminPages.refreshList(adminPages.$refs.select_AdminPagesView_IdLanguage.value);
          //adminPages.setPage(!dataToSave.hideMenu,result.data,result.data,1);
          window.scrollTo(0, 0);
        });
      }
    },
    savePage(publish) {
      if (validationHelpers.isValid("#frmAdminPages")) {
        spinnerHelpers.show();
        var adminPages = this;
        var dataToSave = adminPages.dataToSave(publish);

        if (dataToSave.languagePageSetting[0].url.includes("!") || 
        dataToSave.languagePageSetting[0].url.includes("?") || dataToSave.languagePageSetting[0].url.includes("%")||
        dataToSave.languagePageSetting[0].url.includes("^") || dataToSave.languagePageSetting[0].url.includes("$") ||
        dataToSave.languagePageSetting[0].url.includes("*") || /*dataToSave.languagePageSetting[0].url.includes(".") ||*/
        dataToSave.languagePageSetting[0].url.includes("÷") || dataToSave.languagePageSetting[0].url.includes("±") ||
        dataToSave.languagePageSetting[0].url.includes("°") || dataToSave.languagePageSetting[0].url.includes("@") ||
        dataToSave.languagePageSetting[0].url.includes(":") || dataToSave.languagePageSetting[0].url.includes("§") ||
        dataToSave.languagePageSetting[0].url.includes(":") || dataToSave.languagePageSetting[0].url.includes("§") ||
        dataToSave.languagePageSetting[0].url.includes(";") || dataToSave.languagePageSetting[0].url.includes("#") ||
        dataToSave.languagePageSetting[0].url.includes("'") || dataToSave.languagePageSetting[0].url.includes("£") ||
        dataToSave.languagePageSetting[0].url.includes('"') || dataToSave.languagePageSetting[0].url.includes("&") ||
        dataToSave.languagePageSetting[0].url.includes("=") || dataToSave.languagePageSetting[0].url.includes("€") ||
        dataToSave.languagePageSetting[0].url.includes(">") || dataToSave.languagePageSetting[0].url.includes("<") ||
        dataToSave.languagePageSetting[0].url.includes("¿") || dataToSave.languagePageSetting[0].url.includes("¶") ||
        dataToSave.languagePageSetting[0].url.includes("~") || dataToSave.languagePageSetting[0].url.includes("«") ||
        dataToSave.languagePageSetting[0].url.includes("¢") || dataToSave.languagePageSetting[0].url.includes("ß") ||
        dataToSave.languagePageSetting[0].url.includes("¥") || dataToSave.languagePageSetting[0].url.includes("©") ||
        dataToSave.languagePageSetting[0].url.includes("|") || dataToSave.languagePageSetting[0].url.includes("®") ||
        dataToSave.languagePageSetting[0].url.includes("+") || dataToSave.languagePageSetting[0].url.includes("-") ||
        dataToSave.languagePageSetting[0].url.includes("™") || dataToSave.languagePageSetting[0].url.includes("}") ||
        dataToSave.languagePageSetting[0].url.includes("{") || dataToSave.languagePageSetting[0].url.includes("]") ||
        dataToSave.languagePageSetting[0].url.includes("[")  
        ){
          dataToSave.languagePageSetting[0].url =  dataToSave.languagePageSetting[0].url.replace(/([,\!\^\$\.\*\÷\±\¿\¶\~\«\¢\ß\¥\™\©\®\+\?\|\<\>\-\&\€\%\=\"\'\£\#\;\:\§\@\°\s])/g, "-")    
        }

         if (dataToSave.languagePageSetting[0].url.includes("à") ||
            dataToSave.languagePageSetting[0].url.includes("á") ||
            dataToSave.languagePageSetting[0].url.includes("è") ||
            dataToSave.languagePageSetting[0].url.includes("ê") ||
            dataToSave.languagePageSetting[0].url.includes("é") ||
            dataToSave.languagePageSetting[0].url.includes("ì") ||
            dataToSave.languagePageSetting[0].url.includes("í") ||
            dataToSave.languagePageSetting[0].url.includes("ò") ||
            dataToSave.languagePageSetting[0].url.includes("ó") ||
            dataToSave.languagePageSetting[0].url.includes("ù") ||
            dataToSave.languagePageSetting[0].url.includes("ú") 
            ){ 
            dataToSave.languagePageSetting[0].url =  dataToSave.languagePageSetting[0].url
            .replace(/([\à\s])/g, "a")  
            .replace(/([\á\s])/g, "a")
            .replace(/([\è\s])/g, "e")
            .replace(/([\ê\s])/g, "e")
            .replace(/([\é\s])/g, "e")
            .replace(/([\ì\s])/g, "i")
            .replace(/([\í\s])/g, "i")
            .replace(/([\ò\s])/g, "o")
            .replace(/([\ó\s])/g, "o")
            .replace(/([\ù\s])/g, "u")
            .replace(/([\ú\s])/g, "u");
        }

        if (adminPages.pageValueSelected.id == 0 || !functionHelpers.isValued(adminPages.pageValueSelected.id)) {

          switch (adminPages.typePage) {
            case "Pages":
              
              pageServices.insert(dataToSave, function(result) {
                notificationHelpers.success(
                  dictionaryHelpers.getDictionary("InsertCompleted")
                );
                adminPages.refreshList(
                  adminPages.pageValueSelected.languagePageSetting.idLanguage
                );
                adminPages.setPage(!dataToSave.hideMenu, result.data, null, 0);
                window.scrollTo(0, 0);
              });
              break;
            case "Link":
              menuServices.insertLink(dataToSave, function(result) {
                notificationHelpers.success(
                  dictionaryHelpers.getDictionary("InsertCompleted")
                );
                adminPages.refreshList(
                  adminPages.pageValueSelected.languagePageSetting.idLanguage
                );
                adminPages.setPage(
                  !dataToSave.hideMenu,
                  result.data,
                  result.data,
                  1
                );
                window.scrollTo(0, 0);
              });
              break;
            case "Folder":
              menuServices.insertFolder(dataToSave, function(result) {
                notificationHelpers.success(
                  dictionaryHelpers.getDictionary("InsertCompleted")
                );
                adminPages.refreshList(
                  adminPages.pageValueSelected.languagePageSetting.idLanguage
                );
                adminPages.setPage(
                  !dataToSave.hideMenu,
                  result.data,
                  result.data,
                  2
                );
                window.scrollTo(0, 0);
              });
              break;
            default:
              pageServices.insert(dataToSave, function(result) {
                notificationHelpers.success(
                  dictionaryHelpers.getDictionary("InsertCompleted")
                );
                adminPages.refreshList(
                  adminPages.pageValueSelected.languagePageSetting.idLanguage
                );
                adminPages.setPage(!dataToSave.hideMenu, result.data, null, 0);
                window.scrollTo(0, 0);
              });
              break;
          }
        } else {
          switch (adminPages.typePage) {
            case "Pages":
             
              pageServices.update(dataToSave, function() {
                notificationHelpers.success(dictionaryHelpers.getDictionary("UpdateCompleted"));
                adminPages.refreshList(adminPages.pageValueSelected.languagePageSetting.idLanguage);
                adminPages.setPage(!dataToSave.hideMenu,dataToSave.id,null,0);
                window.scrollTo(0, 0);
              });
              break;
            case "Link":
              menuServices.updateLink(dataToSave, function() {
                notificationHelpers.success(
                  dictionaryHelpers.getDictionary("InsertCompleted")
                );
                adminPages.refreshList(
                  adminPages.pageValueSelected.languagesMenus.idLanguage
                );
                adminPages.setPage(
                  !dataToSave.hideMenu,
                  dataToSave.id,
                  dataToSave.id,
                  1
                );
                window.scrollTo(0, 0);
              });
              break;
            case "Folder":
              menuServices.updateFolder(dataToSave, function() {
                notificationHelpers.success(
                  dictionaryHelpers.getDictionary("InsertCompleted")
                );
                adminPages.refreshList(
                  adminPages.pageValueSelected.languagesMenus.idLanguage
                );
                adminPages.setPage(
                  !dataToSave.hideMenu,
                  dataToSave.id,
                  dataToSave.id,
                  2
                );
                window.scrollTo(0, 0);
              });
              break;
            default:
              pageServices.update(dataToSave, function() {
                notificationHelpers.success(
                  dictionaryHelpers.getDictionary("UpdateCompleted")
                );
                adminPages.refreshList(
                  adminPages.pageValueSelected.languagePageSetting.idLanguage
                );
                adminPages.setPage(
                  !dataToSave.hideMenu,
                  dataToSave.id,
                  null,
                  0
                );
                window.scrollTo(0, 0);
              });
              break;
          }
        }
      }
    },

    getImage(page) {
      $("#modalImgBlogForm").modal("show"); 
      var adminPages = this;
      var data = {
        page : page,
        search : $('#search').val(),
        month : $('#month').val(),
        year : $('#year').val(),
      }; 
      pageServices.getByFile(data, function (result) {
        if(adminPages.resultFilePopups.length == 0 || page == 1){
          adminPages.resultFilePopups = result.data;
          $('#ul-image').css('max-height', window.innerHeight - 200);
        }else{
          var array1 = adminPages.resultFilePopups;
          var array2 = result.data;
          var newArray = array1.concat(array2);
          adminPages.resultFilePopups = newArray;
        }
      }); 
  },

    selectImg(img,imgName) {
    var adminPages = this; 
    $("#modalImgBlogForm").modal("hide");
    adminPages.pageValueSelected.languagePageSetting.urlCoverImage = img;
    adminPages.pageValueSelected.languagePageSetting.imgName ='';
    adminPages.pageValueSelected.languagePageSetting.urlShareImage = img;
    adminPages.pageValueSelected.languagePageSetting.imgNameShare ='';
    adminPages.img = img;
    },

    Search() {
    var adminSettingNews = this;
      adminSettingNews.getImage(1); 
  },

 handleScroll(){
      if($('#ul-image').scrollTop() + $('#ul-image').innerHeight() >= $('#ul-image')[0].scrollHeight) {
        this.getImage(this.pageImage + 1);
        this.pageImage = this.pageImage + 1;
      }
    },

  changeSeoDescription(field, value) {
       var adminPages = this;
       var seoDescriptiontoShareDescription = $("#languagePageSetting\\.seoDescription").val();

       if (seoDescriptiontoShareDescription == '' || seoDescriptiontoShareDescription == null || seoDescriptiontoShareDescription == 'null' || seoDescriptiontoShareDescription == 0) {
        var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoDescription_feedback').remove();
        $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
  }else{
      if (seoDescriptiontoShareDescription.length >= 0 && seoDescriptiontoShareDescription.length <= 70){
          var d = ((87 * seoDescriptiontoShareDescription.length)/70) + "%";
          $('#languagePageSetting_seoDescription_feedback').remove();
          $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom:-126px;left: 13px;"></div>')
      }

      if (seoDescriptiontoShareDescription.length > 70 && seoDescriptiontoShareDescription.length <= 155){
          var d = ((87 * seoDescriptiontoShareDescription.length)/155) + "%";
          $('#languagePageSetting_seoDescription_feedback').remove();
          $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -126px;left: 13px;"></div>')
      }

      if (seoDescriptiontoShareDescription.length > 155 && seoDescriptiontoShareDescription.length <= 2000){
          var d = ((87 * seoDescriptiontoShareDescription.length)/2000) + "%";
          $('#languagePageSetting_seoDescription_feedback').remove();
          $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -126px;left: 13px;"></div>')
      }

        var cleanShareDescription = seoDescriptiontoShareDescription;  
        if (adminPages.pageValueSelected.id == null || $("#languagePageSetting_shareDescription").val() == "") {
          $("#languagePageSetting_shareDescription").val(cleanShareDescription);
          adminPages.pageValueSelected.languagePageSetting.shareDescription = dataHelpers.unbind(cleanShareDescription);
        }
  }
    },


keyupSeoTitle(field, value) {
 var adminSettingNews = this;

    var SeotitleToTitles= $("#languagePageSetting_seoTitle").val();

    if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
    }else{
       if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((87 * SeotitleToTitles.length)/30) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
    }
      if (SeotitleToTitles.length > 30 && SeotitleToTitles.length <= 60){
          var d = ((87 * SeotitleToTitles.length)/60) + "%";
          $('#languagePageSetting_seoTitle_feedback').remove();
          $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length > 60 && SeotitleToTitles.length <= 1000){
          var d = ((87 * SeotitleToTitles.length)/1000) + "%";
          $('#languagePageSetting_seoTitle_feedback').remove();
          $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }

 },

keyupSeoDescription(field, value) { 
   var adminPages = this;
       var seoDescriptiontoShareDescription = $("#languagePageSetting\\.seoDescription").val();

  if (seoDescriptiontoShareDescription == '' || seoDescriptiontoShareDescription == null || seoDescriptiontoShareDescription == 'null' || seoDescriptiontoShareDescription == 0) {
        var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoDescription_feedback').remove();
        $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: -126px;left: 13px;"></div>')
  }else{
      if (seoDescriptiontoShareDescription.length >= 0 && seoDescriptiontoShareDescription.length <= 70){
          var d = ((87 * seoDescriptiontoShareDescription.length)/70) + "%";
          $('#languagePageSetting_seoDescription_feedback').remove();
          $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom:-126px;left: 13px;"></div>')
      }

      if (seoDescriptiontoShareDescription.length > 70 && seoDescriptiontoShareDescription.length <= 155){
          var d = ((87 * seoDescriptiontoShareDescription.length)/155) + "%";
          $('#languagePageSetting_seoDescription_feedback').remove();
          $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: -126px;left: 13px;"></div>')
      }

      if (seoDescriptiontoShareDescription.length > 155 && seoDescriptiontoShareDescription.length <= 2000){
          var d = ((87 * seoDescriptiontoShareDescription.length)/2000) + "%";
          $('#languagePageSetting_seoDescription_feedback').remove();
          $('#languagePageSetting\\.seoDescription').after('<div id="languagePageSetting_seoDescription_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: -126px;left: 13px;"></div>')
      }

        var cleanShareDescription = seoDescriptiontoShareDescription;  
        if (adminPages.pageValueSelected.id == null || $("#languagePageSetting_shareDescription").val() == "") {
          $("#languagePageSetting_shareDescription").val(cleanShareDescription);
          adminPages.pageValueSelected.languagePageSetting.shareDescription = dataHelpers.unbind(cleanShareDescription);
        }
  }

},

  changeSeoTitle(field, value) {
    var adminSettingNews = this;

    var SeotitleToTitles= $("#languagePageSetting_seoTitle").val();

      if (SeotitleToTitles == '' || SeotitleToTitles == null || SeotitleToTitles == 'null' || SeotitleToTitles == 0) {
        var d = ((87 * 10)/100) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(8.7%); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
    }else{
       if (SeotitleToTitles.length >= 0 && SeotitleToTitles.length <= 30){
        var d = ((87 * SeotitleToTitles.length)/30) + "%";
        $('#languagePageSetting_seoTitle_feedback').remove();
        $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #FF0000;position: relative;bottom: 15px;left: 13px;"></div>')
    }
      if (SeotitleToTitles.length > 30 && SeotitleToTitles.length <= 60){
          var d = ((87 * SeotitleToTitles.length)/60) + "%";
          $('#languagePageSetting_seoTitle_feedback').remove();
          $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #28D11B;position: relative;bottom: 15px;left: 13px;"></div>')
      }
      if (SeotitleToTitles.length > 60 && SeotitleToTitles.length <= 1000){
          var d = ((87 * SeotitleToTitles.length)/1000) + "%";
          $('#languagePageSetting_seoTitle_feedback').remove();
          $('#languagePageSetting_seoTitle').before('<div id="languagePageSetting_seoTitle_feedback" style="width: calc(' + d + '); height: 5px;background: #F8AF00;position: relative;bottom: 15px;left: 13px;"></div>')
      }
    }
    },

    changeTitle(field, value) {
      var adminPages = this;
      var titleToTitles= $("#languagePageSetting_title").val();
      var cleanShareTitle = titleToTitles;  
    if (adminPages.pageValueSelected.id == null || $("#languagePageSetting_shareTitle").val() == "") {
        $("#languagePageSetting_shareTitle").val(cleanShareTitle);
        adminPages.pageValueSelected.languagePageSetting.shareTitle = dataHelpers.unbind(cleanShareTitle);
    }

      var titleToUrl = $("#languagePageSetting_title").val(),
        cleanUrl = "";
      cleanUrl =
        "/" +
        titleToUrl
          .replace(/([,\!\^\$\.\*\÷\±\¿\¶\~\«\¢\ß\¥\™\©\®\+\?\|\<\>\-\&\€\%\=\"\'\£\#\;\:\§\@\°\s])/g, "-")
          .replace(/([\à\s])/g, "a")
          .replace(/([\á\s])/g, "a")
          .replace(/([\è\s])/g, "e")
          .replace(/([\ê\s])/g, "e")
          .replace(/([\é\s])/g, "e")
          .replace(/([\ì\s])/g, "i")
          .replace(/([\í\s])/g, "i")
          .replace(/([\ò\s])/g, "o")
          .replace(/([\ó\s])/g, "o")
          .replace(/([\ù\s])/g, "u")
          .replace(/([\ú\s])/g, "u")
          .replace(/([\ż\s])/g, "z")
          .replace(/([\ź\s])/g, "z")
         	.replace(/([\ź\s])/g, "n")
          .replace(/([\ń\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")
          .replace(/([\ņ\s])/g, "n")  
          .toLowerCase();

      for (var i=0; i<100; i++){
        if (cleanUrl.includes('--')) { 
          cleanUrl = cleanUrl.replace('--', '-');
        }else{
          break;
        } 
      }

       var myString = cleanUrl;
        var stringLength = myString.length;
        var lastChar = myString.charAt(stringLength - 1);

        if (lastChar == '-') {
           var cleanUrl = myString.substring(0, myString.length - 1); 
            $("#languagePageSetting_url").val(cleanUrl);
            $("#languagePageSetting_urlCanonical").val(cleanUrl);
        }
        
      if (adminPages.pageValueSelected.id == null || $("#languagePageSetting_url").val() == "" ) {
        $("#languagePageSetting_url").val(cleanUrl);
        $("#languagePageSetting_urlCanonical").val(cleanUrl);
        adminPages.pageValueSelected.languagePageSetting.url = dataHelpers.unbind(cleanUrl);
        adminPages.pageValueSelected.languagePageSetting.urlCanonical = dataHelpers.unbind(cleanUrl);
      }
      this.checkUrl(cleanUrl);
    },

    checkUrl(url) {
      if (url == "languagePageSetting_url") {
        url = $("#" + url).val();
      }
      var adminPages = this;

      if (adminPages.showBtnContentAdminPagesView) {
        if (adminPages.pageValueSelected.id == null) {
          pageServices.checkExistUrl(url, function(result) {
            if (result.data) {
              validationHelpers.setDetailError(
                "languagePageSetting_url",
                dictionaryHelpers.getDictionary("UrlAlreadyExist")
              );
            } else {
              $("#languagePageSetting_url").removeClass("error");
              validationHelpers.clear("#frmAdminPages");
            }
          });
        } else {
          pageServices.checkExistUrlNotForThisPage(
            url,
            adminPages.pageValueSelected.id,
            function(result) {
              if (result.data) {
                validationHelpers.setDetailError(
                  "languagePageSetting_url",
                  dictionaryHelpers.getDictionary("UrlAlreadyExist")
                );
              } else {
                $("#languagePageSetting_url").removeClass("error");
                validationHelpers.clear("#frmAdminPages");
              }
            }
          );
        }
      }
    },
    dataToSave(publish) {
      var adminPages = this;
      var dataToSave = {};
      var languageFound = false;

      $.each(adminPages.pageValueDataToSave, function(i, dataToSave) {
        if (dataToSave.idLanguage == adminPages.pageValueSelected.languagePageSetting.idLanguage) {
          switch (adminPages.typePage) {
            case "Link":
            case "Folder":
              if (functionHelpers.isValued(i)) {
                i = i;
              }
              adminPages.pageValueDataToSave[i] = dataHelpers.unbind(adminPages.pageValueSelected.languagesMenus);
              adminPages.pageValueDataToSave[i][
                "idLanguage"
              ] = dataHelpers.unbind(
                adminPages.pageValueSelected.languagePageSetting.idLanguage
              );
              break;
            case "Pages":
            default:
              adminPages.pageValueDataToSave[i] = dataHelpers.unbind(
                adminPages.pageValueSelected.languagePageSetting
              );
              break;
          }
          languageFound = true;
        }
      });

      if (!languageFound) {
        switch (adminPages.typePage) {

          case "Link":
          case "Folder":
            var i = 0;
            if (functionHelpers.isValued(adminPages.pageValueDataToSave.length)) {
              i = adminPages.pageValueDataToSave.length;
              }
         
            adminPages.pageValueDataToSave[i] = dataHelpers.unbind(adminPages.pageValueSelected.languagesMenus);
            adminPages.pageValueDataToSave[i]["idLanguage"] = dataHelpers.unbind(adminPages.pageValueSelected.languagesMenus.idLanguage);
            break;
          case "Pages":
          default:
            adminPages.pageValueDataToSave[adminPages.pageValueDataToSave.length] = dataHelpers.unbind(adminPages.pageValueSelected.languagePageSetting);
            break;
        }
      }
      $.each(adminPages.pageValueSelected, function(field, value) {
        switch (field) {
          case "languagePageSetting":
            dataToSave[field] = adminPages.pageValueDataToSave;
            break;
          case "languagesMenus":
            dataToSave[field] = adminPages.pageValueDataToSave;
            //dataToSave[field]['idLanguage'] = adminPages.pageValueDataToSave.languagePageSetting;
            break;
          /*case "pageType":
              dataToSave[field] = adminPages.typePage;
            break;*/
          default:
            dataToSave[field] = configurationHelpers.getValueToSave(
              value,
              adminPages.getFieldType(field)
            );
            break;
        }  

      });

      if (publish) {
        dataToSave.online = publish;
      }

      dataToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
      dataToSave.idUser = $("#user_id").val();

      return dataToSave;
    },
    updateContenuto(value) {
      this.pageValueSelected.languagePageSetting.content = value;
    },
    clonePage(id) {
      var adminPages = this;
      spinnerHelpers.show();
      pageServices.clone(id, function() {
        adminPages.refreshList();
        spinnerHelpers.hide();
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("CloneCompleted")
        );
      });
    },
    deletePage(id) {
      var adminPages = this;
      if (confirm("Vuoi eliminare la pagina?")) {
        adminPages.executeCancelData(id);
      }
    },
    
    executeCancelData(id) {
      var adminPages = this;
      spinnerHelpers.show();
      pageServices.del(id, function() {
        adminPages.refreshList();
        spinnerHelpers.hide();
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );
      });
    },
    updateOnlinePage(valueOnline, id) {
      var adminPages = this;
      spinnerHelpers.show();
      if (valueOnline === null) {
        valueOnline = true;
      }
      pageServices.postOnlinePage(valueOnline, id, function() {
        adminPages.refreshList();
        spinnerHelpers.hide();
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("UpdateCompleted")
        );
      });
    }
  }
};
</script>

<style scoped>
.dragArea {
  min-height: 50px;
  outline: 1px dashed;
}
.prova {
  width: 100%;
  text-align: left;
}
.li-menu-drag {
  position: relative;
  border: 1px solid #d7d7d7;
  margin-top: 4px;
  border-radius: 10px;
  padding-left: 4px;
  margin-left: -5px;
  margin-right: 5px;
  overflow: hidden;
  background: #fff;
}
.li-menu-drag:hover {
  background: #F7F7F7;
} 

.div-cont-rapid-icon {
  position: absolute;
  right: 0;
  bottom: 5px;
  z-index: 0;
  padding: 0px 0px 0px 5px;
}
.button span {
  padding: 0;
  display: inline-block;
}
.fa-file-text-o:before {
  margin-top: 5px;
}
.btn-link {
  display: inline-flex;
  overflow: hidden;
  white-space: nowrap;
}
.nav-icon {
  margin-top: 3px;
}
.fa-copy:before,
.fa-files-o:before {
  color: #666;
  font-size: 13px;
}
.fa-trash:before {
  color: #bf395f;
}
.card-header>i {
  margin-right: 0rem;
}
#accordion .card-header, .card .card-header {
  background: #2a3545 !important;
  border-bottom: 3px solid #f45f00 !important;
}
#accordion .card-header h5 button, .card .card-header h5  {
  color: #fff;
  font-weight: bold;
  letter-spacing: .5px;
  display:inline;
  font-size: 15px;
  text-transform: uppercase;
}
#accordion .card-header .fa, .card .card-header .fa {
  color: #fff;
}

/* progress bar page speed */
.meter { 
	height: 20px;
  position: relative;
  border: 3px dashed #ededed;
  border-radius: 25px;
  padding: 10px 4px;
  -webkit-box-shadow: inset 0 -1px 1px rgba(255,255,255,0.3);
  box-shadow: inset 0 -1px 1px rgba(255,255,255,0.3);
  border-radius: 3px;
}
.meter > span {
  display: block;
  margin-top: -7px;
  height: 14px;
  border-radius: 3px;
  background-color: rgb(43,194,83);
  position: relative;
  overflow: hidden;
}
.greenTitle {
  color:#0BCE6B !important;
}
.greenBkg {
  background:#0BCE6B !important;
}

.orangeTitle {
  color:#FFA300 !important;
}
.orangeBkg {
  background:#FFA300 !important;
}

.redTitle {
  color:#FF4E42 !important;
}
.redBkg {
  background:#FF4E42 !important;
}

#imgAggUpload[type="file"] {
  display: none;
}
.custom-file-upload {
  padding: 20px;
  cursor: pointer;
  text-align: center;
  font-weight: lighter;
  border: 3px dashed #ededed;
  border-radius: 10px;
  color: slategrey;
}
.contPreviewImage {
  padding: 15px;
  margin: 2px;
  border: 2px solid #ededed;
  cursor: pointer;
}
.modal{
    margin-left: 6px;
    padding: 7px;
}
#col-form-label {
    color: rgba(0,0,0,.6);
    font-size: 12px;
    font-weight: lighter;
    margin-bottom: -15px;
    min-height: 15px;
    max-height: 15px;
}
.labelPageCategories{
  margin-bottom:0.2rem;
}
#titlePageTabPublication{
  margin-top: -21px;
  position: absolute;
  background: #fff;  
}
.checkboxPageCategories{
  margin-right:5px;
}
.list-group-item{
  margin-bottom: 5px;
  height: 105px;
  padding: 0px;
  background: #ededed;
  border-radius: 0px;
}
#ul-image{
  width: 100%;
  flex-direction: row;
  display: flex;
  flex-wrap: wrap;
  max-height: 50px;
  overflow:auto;
}
.listLi {
  list-style: none;
  text-align: center;
}
.labelListImage {
  cursor: pointer;
  font-size: 12px;
  padding: 2px;
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  background: rgba(255,255,255,0.7);
}

/* end progress bar page speed */

.modal-dialo-pages{
  margin-left: calc(1vw);
  padding: 7px;
  width: calc(98vw);
  height: calc(99vh);
}

.div-extension-img{
    position: absolute;
    bottom: 0px;
    left: 0px;
    background: #238AE6;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
    box-shadow: 0px 0px 7px -2px rgb(0 0 0 / 30%);
}

.div-extension-img label {
    font-size: 10px;
    margin: 0px !important;
    display: block;
    color: #fff;
    font-weight: bold;
}

.home {
  color:#1ea076!important;
  font-size: 1rem!important;
  margin-top: 2px!important;
}

.li-menu-drag:active {
    background: #e4ecf1;
}
.activeMenu{
    background: #e4ecf1;
}
</style>